import axios from "axios";
import {request, setAuthInHeader} from "@/api/request";

const getTempPasswordAuthConfig = () => {
    const authorization = axios.defaults.headers.common.Authorization
        || (window.__RAINBOW_VOLATILE_TOKEN__ ? `Bearer ${window.__RAINBOW_VOLATILE_TOKEN__}` : '');

    return authorization ? {headers: {Authorization: authorization}} : {};
};


let $api = {
    $auth: { // 계정 로그인
        login(params) {
            return request.javaPost("v1/member/WEB/login", params).then(({data}) => data);
        },
        social(params) {
            let type = params.socialType;
            delete params.socialType;
            return request.javaPost(`v1/public/member/WEB/social/${type}/login`, params).then(({data}) => data);
        },
        autoLoginCheckInCheck(params) {
            return request.javaGet('v1/member/WEB/login/chk/auto', params).then(({data}) => data);
        },
        autoLoginCheckIn(params) {
            return request.javaPost('v1/member/WEB/login/auto', params).then(({data}) => data);
        },
    },
    $member: {
        createMember(params) { // 회원가입
            return request.javaPost(`v2/public/member/WEB/signUp`, params).then(({data}) => data);
        },
        createSocialMember(params) {
            return request.javaPost(`v2/member/WEB/social/additional-info`, params).then(({data}) => data);
        },
        checkIdDuplicate(params) { //아이디 중복 확인
            let mbId = params.mbId;
            delete params.mbId;
            return request.javaGet(`v1/member/WEB/chk/id/${mbId}`, params).then(({data}) => data);
        },
        getMemberInfo(params) {
            return request.javaGet('v1/member/WEB/info', params).then(({data}) => data);
        },
        checkTempPasswordStatus(params = {}) {
            return request.javaGet('v1/member/WEB/chk/temp/password', params, getTempPasswordAuthConfig()).then(({data}) => data);
        },



        sendPhoneUnstopCertification(params) { //정지 해제용
            return request.javaPost("v1/public/member/WEB/unstop/send", params).then(({data}) => data);
        },

        sendPhoneFindIdCertification(params) {//아이디 찾기용
            return request.javaPost("v1/public/member/WEB/find-id/send", params).then(({data}) => data);
        },

        checkFirstLogin(params) { //최초로그인 이후 인증
            return request.javaPost("v1/public/member/WEB/verify", params).then(({data}) => data);
        },

        checkOldPwd(params) {
            return request.javaPost("v1/member/WEB/chk/password", params).then(({data}) => data);
        },
        updateMemberPwd(params) { // 회원수정
            return request.javaPatch("v1/member/WEB/password", params).then(({data}) => data);
        },
        updateTempMemberPwd(params) {
            return request.javaPatch("v1/member/WEB/temp/password", params, getTempPasswordAuthConfig()).then(({data}) => data);
        },

        updateMemberArea(params) {
            return request.javaPatch("v1/member/WEB/region", params).then(({data}) => data);
        },
        updateMemberAddress(params) {
            return request.javaPatch("v1/member/WEB/address", params).then(({data}) => data);
        },
        memberLeave(params) { // 회원탈퇴
            return request.javaDelete("v1/member/WEB/withdraw", params).then(({data}) => data);
        },
        updateAlert(params) { //알림 설정
            return request.javaPatch("v1/member/WEB/alarm", params).then(({data}) => data);
        },
        findId(params) { //아이디찾기
            return request.javaPost("v1/public/member/WEB/find-id/verify", params).then(({data}) => data);
        },
        findPwdSend(params) { //비번찾기(문자 찾기)
            return request.javaPost("v1/public/member/WEB/find-password/send", params).then(({data}) => data);
        },
        findPwdCheck(params) { //비번찾기(문자 전송)
            return request.javaPost("v1/public/member/WEB/find-password/verify", params).then(({data}) => data);
        },
        skipPwd(params) { //비번 변경 90일
            return request.javaPost("v1/member/WEB/skip/password", params).then(({data}) => data);
        },

        //TODO api 누락
        checkNowPassword(params) {
            return request.javaPost("v1/member/WEB/chk/password", params).then(({data}) => data);
        },


        updatePartner(params) {
            return request.javaPut("v1/member/WEB/member-partner", params).then(({data}) => data);
        },

        updateMemberTel(params) {
            return request.javaPatch("v1/member/WEB/tel", params).then(({data}) => data);
        },

        getPartner(params) {
            return request.javaGet("v1/member/WEB/partners", params).then(({data}) => data);
        },
        deletePartner(params) {
            return request.javaPatch("v1/member/WEB/member-partner", params).then(({data}) => data);
        },
        createPartner(params) {
            return request.javaPost("v1/member/WEB/member-partner", params).then(({data}) => data);
        },
        getDeliveryList(params) {
            return request.javaGet("v1/delivery/WEB", params).then(({data}) => data);
        },
        addDelivery(params) {
            return request.javaPost("v1/delivery/WEB", params).then(({data}) => data);
        },
        editDelivery(params) {
            let mdIdx = params.mdIdx;
            delete params.mdIdx;
            return request.javaPut(`v1/delivery/WEB/${mdIdx}`, params).then(({data}) => data);
        },
        deleteDelivery(params) {
            let mdIdx = params.mdIdx;
            return request.javaDelete(`v1/delivery/WEB/${mdIdx}`, params).then(({data}) => data);
        },

        getOrderCnt(params) {
            return request.javaGet("v1/order/count", params).then(({data}) => data);
        },
        getOrderCancelCnt(params) {
            return request.javaGet("v1/order/cancel/count", params).then(({data}) => data);
        },

        updateAdultPassword(params) {
            return request.javaPatch('v1/member/WEB/adult/password', params).then(({data}) => data);
        },
        checkAdultPassword(params) {
            return request.javaPost('v1/member/WEB/adult/password/check', params).then(({data}) => data);
        },
        updateConfig(params) {
            return request.javaPost('v1/member/WEB/delivery/config', params).then(({data}) => data);
        },
        recommendUser(params) {
            // 추천인등록
            return request.javaPost("v1/member/WEB/recommend", params).then(({data}) => data);
        },
        getRecommendUser(params) {
            // 추천인등록
            return request.javaGet("v1/member/WEB/recommend/status", params).then(({data}) => data);
        },
        getPartnerStatus(params) {
            return request.javaGet(`v1/member/WEB/partners/status`, params).then(({data}) => data);
        },
        getChannelDisplay(params) {
            return request.javaGet("v1/user/channel/display/WEB", params).then(({data}) => data);
        },
    },
    $ad: {
        getAd(params) {
            return request.javaGet("v1/advertise/WEB/uploads", params).then(({data}) => data);
        },
        getAdDetail(params) {
            let key = params.idx;
            delete params.idx;
            return request.javaGet(`v1/advertise/WEB/${key}`, params).then(({data}) => data);
        },
        deleteAd(params) {
            let key = params.acIdx;
            delete params.acIdx;
            return request.javaDelete(`v1/advertise/WEB/${key}`, params).then(({data}) => data);
        },
        getAdItem(params) {
            return request.javaGet("v1/item/WEB/advertise", params).then(({data}) => data);
        },
        createBanner(params) {
            return request.javaPost(`v1/advertise/WEB/banner`, params).then(({data}) => data);
        },
        createInStream(params) {
            return request.javaPost(`v1/advertise/WEB/instream`, params).then(({data}) => data);
        },
        createPopUp(params) {
            return request.javaPost(`v1/advertise/WEB/popup`, params).then(({data}) => data);
        },

        updateBanner(params) {
            let key = params.key;
            delete params.key;
            return request.javaPut(`v1/advertise/WEB/banner/${key}`, params).then(({data}) => data);
        },
        updateInStream(params) {
            let key = params.key;
            delete params.key;
            return request.javaPut(`v1/advertise/WEB/instream/${key}`, params).then(({data}) => data);
        },
        updatePopUp(params) {
            let key = params.key;
            delete params.key;
            return request.javaPut(`v1/advertise/WEB/popup/${key}`, params).then(({data}) => data);
        },
    },
    $config: {
        getGroup(params) {
            return request.javaGet(`v1/group`, params).then(({data}) => data);
        },
        getQuitCategory(params) {
            return request.javaGet('v1/member/WEB/out-categories', params).then(({data}) => data);
        },
        getConfig(params) {
            return request.javaGet("v1/WEB/config", params).then(({data}) => data);
        },
        getArea(params) {
            let type = params.type;
            delete params.type;
            return request.javaGet(`v1/area/${type}`, params).then(({data}) => data);
        },
        getMediaInfo(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/media/type/WEB/${meIdx}`, params).then(({data}) => data);
        },
        getItemInstructionInfo(params) {
            let inType = params.inType;
            delete params.inType;
            return request.javaGet(`v1/item/instruction/WEB/${inType}`, params).then(({data}) => data)
        },


    },
    $main: {
        getMain(params) {
            return request.javaGet("v1/webMain/WEB", params).then(({data}) => data);
        },
    },
    $board: {
        getNotice(params) {
            return request.javaGet(`v1/notice/WEB`, params).then(({data}) => data);
        },
        getNoticeDetail(params) {
            let wrId = params.wrId;
            delete params.wrId;
            return request.javaGet(`v1/notice/WEB/${wrId}`, params).then(({data}) => data);
        },
        getFaq(params) {
            return request.javaGet(`v1/faq/WEB`, params).then(({data}) => data);
        },
        getFaqCategory(params) {
            return request.javaGet("v1/faq/define/category", params).then(({data}) => data);
        },
        getQna(params) {
            return request.javaGet("v1/qna/WEB", params).then(({data}) => data);
        },
        getQnaDetail(params) {
            let wrId = params.wrId;
            delete params.wrId;
            return request.javaGet(`v1/qna/WEB/${wrId}`, params).then(({data}) => data);
        },
        createQna(params) {
            return request.javaPost(`v1/qna/WEB`, params).then(({data}) => data);
        },
        updateQna(params) {
            return request.javaPut(`v1/qna/WEB`, params).then(({data}) => data);
        },
        deleteQna(params) {
            return request.javaDelete(`v1/qna/WEB`, params).then(({data}) => data);
        },


        cancelOrder(params) {
            let key = params.idx;
            delete params.idx;
            return request.javaPatch(`v1/order/shopping/cancel/WEB/${key}`, params).then(({data}) => data);
        },
        cancelDeposit(params) {
            return request.javaDelete(`v1/order/WEB/deposit/cancel`, params).then(({data}) => data);
        },

        getPayment(params) {
            return request.javaGet(`v1/order/WEB/payment-history`, params).then(({data}) => data);
        },
        getPaymentDetail(params) {
            let key = params.key;
            delete params.key;
            return request.javaGet(`v1/order/WEB/payment-history/${key}`, params).then(({data}) => data);
        },
        getPrize(params) {
            return request.javaGet(`v2/prize/WEB/trade-history`, params).then(({data}) => data);
        },

        getShoppingHistory(params) {
            return request.javaGet(`v1/order/WEB/shopping/purchase-history`, params).then(({data}) => data);
        },

        updateExchange(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/order/trade/WEB/${ordIdx}`, params).then(({data}) => data);
        },
        updateRefund(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/order/refund/WEB/${ordIdx}`, params).then(({data}) => data);
        },
        cancelExchange(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/order/trade/withdrawal/WEB/${ordIdx}`, params).then(({data}) => data);
        },
        cancelRefund(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/order/refund/withdrawal/WEB/${ordIdx}`, params).then(({data}) => data);
        },
        donePayment(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/order/done/${ordIdx}`, params).then(({data}) => data);
        },

        getAffiliate(params) {
            return request.javaGet('v1/media/shop/WEB/trade-history', params).then(({data}) => data);
        },


        getAgainPrize(params) {
            return request.javaGet(`v1/again/WEB/trade`, params).then(({data}) => data);
        },
    },
    $terms: {
        getTerms(params) {
            return request.javaGet(`v1/WEB/config`, params).then(({data}) => data);
        },
        getTermsCategory(params) {
            return request.javaGet(`v1/WEB/config/category`, params).then(({data}) => data);
        },
        getTermsDetail(params) {
            let coIdx = params.coIdx;
            delete params.coIdx;
            return request.javaGet(`v2/WEB/config/detail/${coIdx}`, params).then(({data}) => data);
        }
    },

    $alarm: {
        getAlarm(params) {
            return request.javaGet(`v1/alarm/WEB/member`, params).then(({data}) => data);
        },
        deleteAlarm(params) {
            return request.javaDelete(`v1/alarm/WEB/member`, params).then(({data}) => data);
        },
        readAlarm(params) {
            return request.javaPatch("v1/alarm/WEB/member/read", params).then(({data}) => data);
        },
    },
    $pass: {
        getEncryptData(params) {
            return request.javaPost(`v1/public/identification/WEB/nice/encrypt`, params).then(({data}) => data);
        },
        getDecryptData(params) {
            return request.javaGet(`v1/public/identification/WEB/nice/decrypt`, params).then(({data}) => data);
        },

    },
    $mypage: {
        getCoin(params) {
            return request.javaGet(`v1/coin/history/WEB`, params).then(({data}) => data);
        },
        getPoint(params) {
            return request.javaGet(`v1/point/WEB/history`, params).then(({data}) => data);
        },
        pointExchange(convertCode, pointsToExchange) {
            return request.javaPost(`v1/point/WEB/${convertCode}/transferable/${pointsToExchange}`).then(({data}) => data);
        },
        pointMaxExchange(point) {
            return request.javaGet(`v1/point/WEB/check/transferable/${point}`).then(({data}) => data);
        },
        getPointRateCheck(params) {
            return request.javaGet(`v1/point/rate/progress/WEB`, params).then(({data}) => data);
        },
        pointRateExchange(params, convertCode) {
            return request.javaPost(`v1/point/rate/convert/${convertCode}/WEB`, params).then(({data}) => data);
        },

        getMemberCoinBalance(params) {
            return request.javaGet("v1/gold/balance/quantity/WEB", params).then(({data}) => data);
        },

        getMemberPointBalance(params) {
            return request.javaGet("v1/point/WEB/balance", params).then(({data}) => data);
        },

        getMemberCoinUsage(params) {
            return request.javaGet("v1/gold/chk/WEB", params).then(({data}) => data);
        },

        coinTypeConvert(params) {
            return request.javaPost(`v1/coin/convert/WEB`, params).then(({data}) => data);
        },
    },
    $media: {

        getMediaCategory(params) {
            return request.javaGet(`v1/media/WEB/category`, params).then(({data}) => data);
        },
        getMedia(params) {
            return request.javaGet(`v1/media/WEB/uploads`, params).then(({data}) => data);
        },
        getJavaShopList(params) {
            return request.javaGet(`v1/media/shop/WEB/uploads`, params).then(({data}) => data);
        },
        getJavaMediaDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/media/WEB/${meIdx}`, params).then(({data}) => data);
        },
        getJavaShopDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/media/shop/WEB/${meIdx}`, params).then(({data}) => data);
        },
        getShoppingDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/media/shop/WEB/${meIdx}`, params).then(({data}) => data);
        },


        getMediaDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/media/WEB/${meIdx}`, params).then(({data}) => data);
        },
        getShortsDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/media/shorts/WEB/${meIdx}`, params).then(({data}) => data);
        },

        createMedia(params) {
            return request.javaPost(`v1/media/WEB`, params).then(({data}) => data);
        },
        createShop(params) {
            return request.javaPost(`v1/media/shop/WEB`, params).then(({data}) => data);
        },
        updateShop(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/media/shop/WEB/${meIdx}`, params).then(({data}) => data);
        },
        updateMedia(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/media/WEB/${meIdx}`, params).then(({data}) => data);
        },
        deleteMedia(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaDelete(`v1/media/WEB/${meIdx}`, params).then(({data}) => data);
        },
        deleteShop(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaDelete(`v1/media/shop/WEB/${meIdx}`, params).then(({data}) => data);
        },

        getGenre(params) {
            return request.javaGet(`v1/media/WEB/genre`, params).then(({data}) => data);
        },


    },
    $pay: {
        createCart(params) {
            return request.javaPost('v1/cart/WEB', params).then(({data}) => data);
        },
        checkInisisPay(params) {
            return request.javaGet('v1/order/inis/WEB/chk/pay', params).then(({data}) => data);
        },
        createSubscribe(params) {
            return request.javaPost('v1/subscription/WEB', params).then(({data}) => data);
        },
        createOrderAd(params) {
            return request.javaPost('v1/order/ad', params).then(({data}) => data);
        },
        createOrderShopping(params) {
            return request.javaPost('v1/order/shop', params).then(({data}) => data);
        },

        getCouponAble(params) {
            return request.javaGet('v1/coupon/WEB/product', params).then(({data}) => data);
        },
        getBank(params) {
            return request.javaGet('v1/bank/define', params).then(({data}) => data);
        },
        getExpressReason(params) {
            return request.javaGet('v1/express/define/reason', params).then(({data}) => data);
        },
        naverRegistration(params) {
            return request.javaGet('v1/subscription/naverpay/registration/callback', params).then(({data}) => data);
        },
        naverReservation(params) {
            return request.javaPost('v1/subscription/naverpay/reserve', params).then(({data}) => data);
        },
        naverSubscribe(params) {
            return request.javaPost('v1/subscription/naverpay/subscribe', params).then(({data}) => data);
        },
        approveKakao(params) {
            return request.javaPost('v1/order/kakaopay/approve', params).then(({data}) => data);
        },
        readyKakao(params) {
            return request.javaPost('v1/order/kakaopay/ready', params).then(({data}) => data);
        },


    },
    $ga: {
        registerUser(params) {
            return request.postStatistics('member/register', params).then(({data}) => data);
        },
        updateUser(params) {
            return request.postStatistics('member/info/update', params).then(({data}) => data);
        },
        registerPartner(params) {
            return request.postStatistics('partner/register', params).then(({data}) => data);
        },
        uploadMedia(params) {
            return request.postStatisticsJava('v1/statistics/contents', params).then(({data}) => data);
        },
        changeMedia(params) {
            return request.postStatisticsJava('v1/statistics/contents', params).then(({data}) => data);
        },
        deleteGaMedia(params) {
            return request.deleteStatisticsJava('v1/statistics/contents/reason', params).then(({data}) => data);
        },
        updateMediaInfo(params) {
            return request.postStatisticsJava('v1/statistics/contents/reason', params).then(({data}) => data);
        },


        uploadAd(params) {
            return request.postStatistics('ad', params).then(({data}) => data);
        },
        updateAdInfo(params) {
            return request.postStatisticsJava('v1/statistics/ads/reason', params).then(({data}) => data);
        },
        changeAd(params) {
            return request.putStatisticsJava('v1/statistics/ads/watch', params).then(({data}) => data);
        },
        deleteGaAd(params) {
            return request.deleteStatisticsJava('v1/statistics/ads/reason', params).then(({data}) => data);
        },


        changePoint(params) {
            return request.postStatistics('coin-point', params).then(({data}) => data);
        },


        couponUse(params) {
            return request.postStatisticsJava('v1/statistics/coupons/use', params).then(({data}) => data);
        },


    },
    $coupon: {
        getCoupon(params) {
            return request.javaGet('v1/coupon/WEB/member', params).then(({data}) => data);
        }

    },
    $handler: {
        authHeader: setAuthInHeader
    },
    $prize: {
        getPrize(params) {
            return request.javaGet(`v2/prize/WEB/list`, params).then(({data}) => data);
        },
        getPrizeDetail(params) {
            let prIdx = params.prIdx;
            delete params.prIdx;
            return request.javaGet(`v2/prize/WEB/${prIdx}`, params).then(({data}) => data);
        },
        tradePrize(params) {
            let prIdx = params.prIdx;
            let mdIdx = params.mdIdx;
            delete params.prIdx;
            delete params.mdIdx;
            return request.javaGet(`v2/prize/${prIdx}/trade/${mdIdx}/WEB`, params).then(({data}) => data);
        },
        getPrizeCategory(params) {
            return request.javaGet(`v2/prize/category/WEB`, params).then(({data}) => data);
        },
    },
    $mission: {
        getMission(params) {
            return request.javaGet(`v1/point/WEB/mission`, params).then(({data}) => data);
        },
        getAttendanceDate(params) {
            return request.javaGet(`v1/point/WEB/attendance`, params).then(({data}) => data);
        },
        getRouletteList(params) {
            return request.javaGet(`v1/point/WEB/roulette/point`, params).then(({data}) => data);
        },
        moveRoulette(params) {
            return request.javaPost(`v1/point/WEB/roulette`, params).then(({data}) => data);
        },
        dailyMissionCheckInCheck(params) {
            return request.javaGet('v1/point/WEB/mission/chk/attendance', params).then(({data}) => data);
        },
        dailyMissionCheckIn(params) {
            return request.javaPost('v1/point/WEB/mission/attendance', params).then(({data}) => data);
        },
        getMissionCategory(params) {
            return request.javaGet(`v1/event-tap/WEB`, params).then(({data}) => data);
        },

    },
    $promotion: {
        getPrizePromotion(params) {
            return request.javaGet(`v1/promotion/WEB/prize`, params).then(({data}) => data);
        },
        connectionPrizePromotion(params) {
            return request.javaPost(`v1/promotion/WEB/prize/code`, params).then(({data}) => data);
        },
        connectionPointPromotion(params) {
            return request.javaPost(`v1/promotion/WEB/point/code`, params).then(({data}) => data);
        },
        connectionGoldPromotion(params) {
            return request.javaPost(`v1/promotion/WEB/gold/code`, params).then(({data}) => data);
        },
        checkPrizePromotion(params) {
            return request.javaGet(`v1/promotion/WEB/prize/code/available`, params).then(({data}) => data);
        },
    },
    $gold: {
        getGoldBalance(params) {
            return request.javaGet(`v1/gold/balance/quantity/WEB`, params).then(({data}) => data);
        },
        getGoldHistoryList(params) {
            return request.javaGet(`v1/gold/history/WEB`, params).then(({data}) => data);
        }
    },
    $agree: {
        sendAgreeMsg(params) {
            return request.javaPost(`v1/WEB/member/kids/agree`, params).then(({data}) => data);
        },
        getAgreePayment(params) {
            return request.javaGet(`v1/WEB/member/kids/chk/agree`, params).then(({data}) => data);
        },
    },
    $subscript: {
        getSubscriptTarget(params) {
            return request.javaGet('v1/subscription/WEB/notice/confirm/target', params).then(({data}) => data);
        },
        confirmSubscript(params) {
            return request.javaPost('v1/subscription/WEB/notice/confirm', params).then(({data}) => data);
        },
        getSubscriptNotice(params) {
            return request.javaGet('v1/subscription/WEB/notice/confirm/target', params).then(({data}) => data);
        },
        getSubscriptItem(params) {
            return request.javaGet(`v1/item/WEB/subscription`, params).then(({data}) => data);
        },
        getChannelDisplayWebOs(params) {
            return request.javaGet(`v1/user/channel/display/WEBOS`, params).then(({data}) => data);
        },
        getSubScribe(params) {
            return request.javaGet(`v1/subscription/WEB/member/subscribe`, params).then(({data}) => data);
        },

        deleteSubScribe(params) {
            return request.javaDelete(`v1/subscription/WEB`, params).then(({data}) => data);
        },
    },
    $sns: {
        sendSnsEnter(params) {
            return request.javaPost('v1/sns/WEB/enter/statistics', params).then(({data}) => data);
        },
        sendSnsRegister(params) {
            return request.javaPost('v1/sns/WEB/join/statistics', params).then(({data}) => data);
        },
    },
    $gift: {
        getEvent(params) {
            return request.javaGet('v1/WEB/event', params).then(({data}) => data);
        },
        getDdobaCategory(params) {
            return request.javaGet(`v1/again/category/WEB`, params).then(({data}) => data);
        },
        getDdoba(params) {
            return request.javaGet('v1/again/WEB/category', params).then(({data}) => data);
        },
        getDdobaDetail(ddobaIdx, params) {
            return request.javaGet(`v1/again/WEB/${ddobaIdx}`, params).then(({data}) => data);
        },
        hitEvent(evIdx, params) {
            return request.javaPost(`v1/WEB/event/hit/${evIdx}`, params).then(({data}) => data);
        },
        eventViewCountUp(params) {
            return request.javaPost('v1/WEB/event/view', params).then(({data}) => data);
        },

        tradeDdobaPrize(params) {
            let amprIdx = params.amprIdx;
            let mdIdx = params.mdIdx;
            delete params.prIdx;
            delete params.mdIdx;
            return request.javaPost(`v1/again/${amprIdx}/trade/${mdIdx}/WEB`, params).then(({data}) => data);
        },
    }
};

export default $api;
